import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from '../v1/authentication.service';
@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  apiUrl = '/maxi';
  constructor(private httpClient: HttpClient,
    private authService: AuthenticationService) { }

  headers() {
    const currentUser = this.authService.currentUserValue;
    console.log('maxi config current user',currentUser);
    const Authorization = currentUser ? `Bearer ${currentUser.token}` : ''; // + userData.access_token; 
    return { headers: { Authorization } };
  }

  get(url) {
    return this.httpClient.get(this.apiUrl+url,this.headers())
  }

  post(url,body: any) {
    return this.httpClient.post(this.apiUrl + url, body, this.headers())
  }

}
